<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
      <div class="spinner-part spinner-part1"></div>
      <div class="spinner-part spinner-part2"></div>
      <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<div class="container-fluid pl-0">
  <div class="container-inner">
      <ng-container *ngIf="!isCreate">
          <div class="header-container">
              <h2>Users</h2>
              <div class="search-container">
                  <input
                    type="text"
                    [formControl]="searchInput"
                    placeholder="Search..."
                    (input)="applyFilter()"
                    class="form-control"
                  />
                  <span class="clear-icon" *ngIf="searchInput.value" (click)="clearSearch()">&times;</span>
                </div>
              <!-- <div class="button-container">
                  <button mat-raised-button class="add-button" (click)="add()">Add User</button>
              </div>                   -->
          </div>
          <div class="leads-table mb-3">
              <table mat-table [dataSource]="dataSource" matSort class="mat-table">
                  <ng-container matColumnDef="SNo">
                      <th mat-header-cell *matHeaderCellDef> S.No </th>
                      <td mat-cell *matCellDef="let element; let i = index">
                          {{ (paginatorRef.pageIndex * paginatorRef.pageSize)
                          + (i + 1) }}
                      </td>
                  </ng-container>
                  <ng-container matColumnDef="first_name">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
                      <td mat-cell *matCellDef="let element">{{element.first_name ?
                          element.first_name : 'NA'}}</td>
                  </ng-container>
                  <ng-container matColumnDef="role_id">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
                      <td mat-cell *matCellDef="let element">
                          {{ element.role.role }}
                      </td>
                  </ng-container>

                  <ng-container matColumnDef="email">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                      <td mat-cell *matCellDef="let element">{{element.email ?
                          element.email : 'NA'}}</td>
                  </ng-container>
                  <ng-container matColumnDef="username">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>User ID</th>
                      <td mat-cell *matCellDef="let element">{{element.username ?
                          element.username : 'NA'}}</td>
                  </ng-container>
                  <ng-container matColumnDef="mobile">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile</th>
                      <td mat-cell *matCellDef="let element">{{element.mobile
                          ? element.mobile : 'NA'}}</td>
                  </ng-container>
                  <ng-container matColumnDef="outlets">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Outlets</th>
                      <td mat-cell *matCellDef="let element">{{element?.outlet?.outlet_name
                          ? element.outlet.outlet_name : 'NA'}}</td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;">Status</th>
                    <td mat-cell *matCellDef="let element">
                        <div class="status-button-wrapper">
                            <span [ngClass]="element?.status ? 'status-active' : 'status-inactive'">
                                {{ element?.status ? 'Active' : 'InActive' }}
                              </span>
                    </div>
                    </td>
                  </ng-container>
                  <!-- Action Column -->
                  <!-- <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef>Action</th>

                      <td mat-cell *matCellDef="let element" style="text-align: center;">
                          <img [src]="bucketurl + '/images/pen.png'" class="edit-pen" title="Edit"
                              (click)="openEditPopup(element)">
                      </td>
                  </ng-container> -->
                  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
              <mat-paginator #paginatorRef [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
          </div>
      </ng-container>
      <ng-container *ngIf="isCreate">
          <div class="header-container">
              <h2>Users</h2>
              <div class="button-container">
                  <button mat-raised-button class="add-button" (click)="back()">Back to List</button>
              </div>
          </div>
          <form [formGroup]="userForm" autocomplete="off">
              <div class="row">
                  <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                      <div class="themeinput">
                          <label>First Name</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                          <!-- <mat-form-field appearance="outline"> -->
                          <input type="text" class="form-control" formControlName="first_name" maxlength="30"
                              [attr.value]="userForm.get('first_name')?.value"
                              [ngClass]="{ 'is-invalid': submitted && f['first_name'].errors }" />
                          <div class="invalid-feedback" *ngIf="submitted && f['first_name'].errors">
                              <div *ngIf="f['first_name'].errors['required']">First
                                  Name is required</div>
                          </div>
                          <!-- </mat-form-field> -->
                      </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                      <div class="themeinput">
                          <label>Last Name</label>
                          <!-- <mat-form-field appearance="outline"> -->
                          <input type="text" class="form-control" formControlName="last_name" maxlength="30"
                              [attr.value]="userForm.get('last_name')?.value"
                              [ngClass]="{ 'is-invalid': submitted && f['last_name'].errors }" />
                          <div class="invalid-feedback" *ngIf="submitted && f['last_name'].errors">
                              <div *ngIf="f['last_name'].errors['required']">Last
                                  Name is required</div>
                          </div>
                          <!-- </mat-form-field> -->
                      </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                      <div class="themeinput">
                          <label>Email</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                          <!-- <mat-form-field appearance="outline"> -->
                          <input class="form-control" type="email" formControlName="email" maxlength="50"
                              [ngClass]="{ 'is-invalid': submitted && f['email'].errors }"
                              [attr.value]="userForm.get('email')?.value" (ngModelChange)="onEmailChange($event)" />
                          <div class="invalid-feedback" *ngIf="submitted && f['email'].errors">
                              <div *ngIf="f['email'].errors['required']">Email
                                  is required</div>
                              <div *ngIf="f['email'].errors['email']">Invalid
                                  email format</div>
                          </div>
                          <!-- </mat-form-field> -->
                      </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                      <div class="themeinput">
                          <label>User ID</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                          <!-- <mat-form-field appearance="outline"> -->
                          <input class="form-control" type="username" formControlName="username" maxlength="50"
                              [ngClass]="{ 'is-invalid': submitted && f['username'].errors }"
                              [attr.value]="userForm.get('username')?.value" />
                          <div class="invalid-feedback" *ngIf="submitted && f['username'].errors">
                              <div *ngIf="f['username'].errors['required']">User ID
                                  is required</div>
                              <div *ngIf="f['username'].errors['username']">Invalid
                                  user id format</div>
                          </div>
                          <!-- </mat-form-field> -->
                      </div>
                  </div>

                  <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                      <div class="themeinput">
                          <label>Mobile</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                          <!-- <mat-form-field appearance="outline"> -->
                          <input class="form-control" type="text" formControlName="mobile" maxlength="10"
                              (keypress)="keyPress($event)" pattern="[0-9]*"
                              [attr.value]="userForm.get('mobile')?.value"
                              [ngClass]="{ 'is-invalid': submitted && f['mobile'].errors }" />
                          <div class="invalid-feedback" *ngIf="submitted && f['mobile'].errors">
                              <div *ngIf="f['mobile'].errors['required']">Mobile
                                  number is required</div>
                              <div *ngIf="f['mobile'].errors['pattern']">Please
                                  enter valid numbers only</div>
                              <div *ngIf="f['mobile'].errors['maxlength']">Mobile
                                  number must be exactly 10 digits</div>
                          </div>
                          <!-- </mat-form-field> -->
                      </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                      <div class="themeinput">
                          <label>Alternate Mobile</label>
                          <!-- <mat-form-field appearance="outline"> -->
                          <input type="text" class="form-control" formControlName="alternate_mobile" maxlength="10"
                              (keypress)="keyPress($event)" pattern="[0-9]*" autocomplete="new-password"
                              [attr.value]="userForm.get('alternate_mobile')?.value"
                              [ngClass]="{ 'is-invalid': submitted && f['alternate_mobile'].errors }" />
                          <div class="invalid-feedback" *ngIf="submitted && f['alternate_mobile'].errors">
                              <div *ngIf="f['alternate_mobile'].errors['pattern']">Please
                                  enter valid numbers only</div>
                              <div *ngIf="f['alternate_mobile'].errors['maxlength']">Alternate
                                  mobile number must be exactly 10
                                  digits</div>
                          </div>
                          <!-- </mat-form-field> -->
                      </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                      <div class="themeinput">
                          <label>Password</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                          <!-- <mat-form-field appearance="outline"> -->
                          <div class="input-group">

                              <input class="form-control m-0" [type]="showPassword ? 'text' : 'password'"
                                  formControlName="password" maxlength="10" autocomplete="new-password"
                                  [attr.value]="userForm.get('password')?.value"
                                  [ngClass]="{ 'is-invalid': submitted && f['password'].errors }" />
                              <div class="input-group-append">
                                  <span class="input-group-text pwd-eye" (click)="togglePasswordVisibility()">
                                      <i class="fa"
                                          [ngClass]="{'fa-eye-slash': !showPassword, 'fa-eye': showPassword}"></i>
                                  </span>
                              </div>
                              <div class="invalid-feedback" *ngIf="submitted && f['password'].errors">
                                  <div *ngIf="f['password'].errors['required']">Password
                                      is required</div>
                              </div>
                          </div>
                          <!-- </mat-form-field> -->
                      </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                      <div class="themeinput">
                          <label>Role</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                          <!-- <mat-form-field appearance="outline"> -->
                          <select formControlName="role_id" class="form-select"
                              [attr.value]="userForm.get('role_id')?.value"
                              [ngClass]="{ 'is-invalid': submitted && f['role_id'].errors }">
                              <option value="" selected disabled>--Select
                                  Role--</option>
                              <option *ngFor="let roleData of roleValue" [value]="roleData.id">{{ roleData.role
                                  }}</option>
                          </select>
                          <div class="invalid-feedback" *ngIf="submitted && f['role_id'].errors">
                              <div *ngIf="f['role_id'].errors['required']">Role
                                  is required</div>
                          </div>
                          <!-- </mat-form-field> -->
                      </div>
                  </div>
                  <!-- Outlet Dropdown -->
                  <div *ngIf="isOutletRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                      <label>Outlet</label>
                      <span style="color: red; font-size: 15px;">&nbsp;*</span>
                      <select formControlName="outlet_id" class="form-select"
                          [attr.value]="userForm.get('outlet_id')?.value"
                          [ngClass]="{ 'is-invalid': submitted && f['outlet_id'].errors }"
                          (change)="onOutletChange($event)">
                          <option value="" disabled selected>--Select
                              Outlet--</option>
                          <option *ngFor="let outletData of out_letValue" [value]="outletData.id">{{
                              outletData.outlet_name }} - {{outletData.outlet_code}}</option>
                      </select>
                      <div class="invalid-feedback" *ngIf="submitted && f['outlet_id'].errors">
                          <div *ngIf="f['outlet_id'].errors['required']">Outlet
                              is required</div>
                      </div>
                      <!-- <label>Outlet</label>
                      <span style="color: red; font-size: 15px;">&nbsp;*</span>
                      <ng-select 
                          formControlName="outlet_id"
                          [items]="out_letValue"
                          bindLabel="outlet_name"
                          bindValue="id"
                          [placeholder]="' '"
                          [ngClass]="{ 'is-invalid': submitted && f['outlet_id'].errors }">
                      </ng-select>
                      <div class="invalid-feedback" *ngIf="submitted && f['outlet_id'].errors">
                          <div *ngIf="f['outlet_id'].errors['required']">Outlet is required</div>
                      </div> -->
                  </div>
                  <div *ngIf="isSalesRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                      <label>Product Category</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                      <!-- <select formControlName="product_category" class="form-select"
                          [ngClass]="{ 'is-invalid': submitted && f['product_category'].errors }">
                          <option value="" disabled selected>--Select Product Category--</option>
                          <option *ngFor="let prodCat of filterProdCat" [value]="prodCat.category_id">
                              {{ prodCat.product_category }}
                          </option>
                      </select> -->
                      <ng-multiselect-dropdown [placeholder]="'Select Product Category'" formControlName="product_category"
                class="form-control" [settings]="dropdownSettingsProCategory" [data]="filterProdCat"
                [ngClass]="{ 'is-invalid': submitted && f['product_category'].errors }">
              </ng-multiselect-dropdown>
                      <div class="invalid-feedback" *ngIf="submitted && f['product_category'].errors">
                          <div *ngIf="f['product_category'].errors['required']">Product Category is required</div>
                      </div>
                  </div>
                  <div *ngIf="ismspinRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                      <label>SMPIN</label>
                      <span style="color: red; font-size: 15px;">&nbsp;*</span>
                      <select formControlName="mspin" class="form-select"
                          [ngClass]="{ 'is-invalid': submitted && f['mspin'].errors }">
                          <option value="" disabled selected>--Select SMPIN--</option>
                          <option *ngFor="let mspinData of filteredProducts" [value]="mspinData.mspin">
                              {{ mspinData.mspin }}
                          </option>
                      </select>
                      <div class="invalid-feedback" *ngIf="submitted && f['mspin'].errors">
                          <div *ngIf="f['mspin'].errors['required']">SMPIN is required</div>
                      </div>
                  </div>


                  <!-- Area Dropdown -->
                  <div *ngIf="isAreaRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                      <label>Area</label>
                          <span style="color: red; font-size: 15px;">&nbsp;*</span>
                          <ng-select 
                              formControlName="area_id"
                              [items]="areaValue"
                              bindLabel="area_name"
                              bindValue="id"
                              [placeholder]="' '"
                              [ngClass]="{ 'is-invalid': submitted && f['area_id'].errors }">
                          </ng-select>
                          <div class="invalid-feedback" *ngIf="submitted && f['area_id'].errors">
                              <div *ngIf="f['area_id'].errors['required']">Area is required</div>
                          </div>
                  </div>

                  <!-- Zone Dropdown -->
                  <div *ngIf="isZoneRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                      <!-- <label>Zone</label>
                      <span style="color: red; font-size: 15px;">&nbsp;*</span>
                      <select formControlName="zone_id" class="form-select"
                          [attr.value]="userForm.get('zone_id')?.value"
                          [ngClass]="{ 'is-invalid': submitted && f['zone_id'].errors }">
                          <option value="" disabled selected>--Select
                              Zone--</option>
                          <option *ngFor="let zone of zoneValue" [value]="zone.id">{{ zone.zone_name }}</option>
                      </select>
                      <div class="invalid-feedback" *ngIf="submitted && f['zone_id'].errors">
                          <div *ngIf="f['zone_id'].errors['required']">Zone
                              is required</div>
                      </div> -->
                      <label>Zone</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                      <ng-select 
                          formControlName="zone_id"
                          [items]="zoneValue"
                          bindLabel="zone_name"
                          bindValue="id"
                          [placeholder]="' '"
                          [ngClass]="{ 'is-invalid': submitted && f['zone_id'].errors }">
                      </ng-select>
                      <div class="invalid-feedback" *ngIf="submitted && f['zone_id'].errors">
                          <div *ngIf="f['zone_id'].errors['required']">Zone is required</div>
                      </div>
                  </div>

                  <!-- Region Dropdown -->
                  <div *ngIf="isRegionRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                      <!-- <label>Region</label>
                      <span style="color: red; font-size: 15px;">&nbsp;*</span>
                      <select formControlName="region_id" class="form-select"
                          [attr.value]="userForm.get('region_id')?.value"
                          [ngClass]="{ 'is-invalid': submitted && f['region_id'].errors }">
                          <option value="" disabled selected>--Select
                              Region--</option>
                          <option *ngFor="let region of regionValue" [value]="region.id">{{ region.region_name }}
                          </option>
                      </select>
                      <div class="invalid-feedback" *ngIf="submitted && f['region_id'].errors">
                          <div *ngIf="f['region_id'].errors['required']">Region
                              is required</div>
                      </div> -->
                      <label>Region</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                      <ng-select 
                          formControlName="region_id"
                          [items]="regionValue"
                          bindLabel="region_name"
                          bindValue="id"
                          [placeholder]="' '"
                          [ngClass]="{ 'is-invalid': submitted && f['region_id'].errors }">
                      </ng-select>
                      <div class="invalid-feedback" *ngIf="submitted && f['region_id'].errors">
                          <div *ngIf="f['region_id'].errors['required']">Region is required</div>
                      </div>
                  </div>
                  <!-- Parent Dealer -->
                  <div *ngIf="isParentRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                      <!-- <label>Parent Dealer</label>
                      <span style="color: red; font-size: 15px;">&nbsp;*</span>
                      <select formControlName="parent_dealer_id" class="form-select"
                          [attr.value]="userForm.get('parent_dealer_id')?.value"
                          [ngClass]="{ 'is-invalid': submitted && f['parent_dealer_id'].errors }">
                          <option value="" disabled selected>--Select
                              Parent Dealer--</option>
                          <option *ngFor="let parent_dealer of parent_dealerValue" [value]="parent_dealer.id">{{
                              parent_dealer.dealer_name }}</option>
                      </select>
                      <div class="invalid-feedback" *ngIf="submitted && f['parent_dealer_id'].errors">
                          <div *ngIf="f['parent_dealer_id'].errors['required']">Parent Dealer
                              is required</div>
                      </div> -->
                      <label>Parent Dealer</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                      <ng-select 
                          formControlName="parent_dealer_id"
                          [items]="parent_dealerValue"
                          bindLabel="dealer_name"
                          bindValue="id"
                          [placeholder]="' '"
                          [ngClass]="{ 'is-invalid': submitted && f['parent_dealer_id'].errors }">
                      </ng-select>
                      <div class="invalid-feedback" *ngIf="submitted && f['parent_dealer_id'].errors">
                          <div *ngIf="f['parent_dealer_id'].errors['required']">Parent Dealer is required</div>
                      </div>
                  </div>
              </div>
              <div class="col-lg-12 mt-5 two-btn">
                  <div class="text-right-right">
                      <button mat-raised-button class="clear-button" (click)="clearForm()">Clear</button>
                      <button class="create-button ml-2" mat-raised-button (click)="createUser()">Create</button>

                  </div>
              </div>

          </form>
      </ng-container>
  </div>
</div>